module.exports = __webpack_public_path__ + "assetsclientes/img/trophy.1b770c2a.png";